import React, { useEffect, useState } from 'react';
import {AutoComplete, Input, Col} from 'antd';
import {useProdutos} from '../../hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo, faMinusCircle, faBox } from '@fortawesome/pro-duotone-svg-icons';
import Button, { convertLegacyProps } from 'antd/lib/button/button';


const { Option } = AutoComplete;

const AutoCompleteProdutos = (props) => {

    const {onSelectProduto, onChange, value} = props;
    
   // const produtoSelecionadoInicial = ((value && value.produtoSelecionado[0]) || false);
    
    
    
    const {listarProdutosEstoque} = useProdutos();
    const [produtos, setProdutos] = useState([]);
    const [options, setOptions] = useState([]);
    const [produtoSelecionado, setProdutoSelecionado] = useState(false);
    
    console.log(produtoSelecionado);
    

    // useEffect(()=>{
        
    //     if(produtoSelecionadoInicial && typeof value !== "string"){
    //         setProdutoSelecionado(produtoSelecionadoInicial);
    //     }
    // },[value, produtos.length]);

    useEffect(() => {
    
        lerProdutosDb();
    
       // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
    
        defineValorInicial();
    
       // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [produtos]);

    const defineValorInicial = () => {

        let produtosEstoque = produtos;
        const produtoInicial = produtosEstoque.filter((produto) => {
            return produto.codigo == value || produto.uuid == value;
        })

        if(produtoInicial && produtoInicial.length){
            setProdutoSelecionado(produtoInicial[0]);
        }
    
    }

  

    const lerProdutosDb = async() => {
        let produtosEstoque = produtos;
        if(!produtosEstoque.length){
            produtosEstoque = await listarProdutosEstoque();
        }

        setProdutos(produtosEstoque);

    }
    
    const onFilter = (force = false) => async(filtro) => {

        if(force){
            await lerProdutosDb();
        }

        const filtroUpper = (filtro || "").toUpperCase();
        const produtodFiltrados = produtos.filter(produto => {
            const descUpper = produto.descricao.toUpperCase();
            const codUpper = produto.codigo.toUpperCase();
            const retorno = ( descUpper.indexOf(filtroUpper) >=0 ||
                              codUpper.indexOf(filtroUpper) >=0
                            )

            return retorno;
        })        
        defineOptions(produtodFiltrados);
    };

    const defineOptions = (produtos) =>{
        if(produtos){

            let options = produtos.map(produto => {
                return {
                    key: produto.uuid,
                    value: produto.uuid,
                    label: produto.descricao
                }
            });
            
    
    
            setOptions(options);
        }

    }

    const onSelect = (produto) => {
        const produtoSelecionado = produtos.filter(p => p.uuid == produto);
        setProdutoSelecionado(produtoSelecionado[0]);
        onSelectProduto && onSelectProduto(produtoSelecionado[0]);
        onChange && onChange({
            produtoSelecionado,
            ...value            
        });
        //onSelectProduto(produto)
    }

    const devinculaItem = () => {
        setProdutoSelecionado(false);
        onSelectProduto && onSelectProduto(false);
        onChange && onChange({
            produtoSelecionado: false            
        });
    }


    if(produtoSelecionado){
        return (<>
        <Col span={24} style={{textAlign: 'left', background: "rgb(255 255 255 / 31%)", padding: '4px 15px 1px'}}>
                <h3>
                    <FontAwesomeIcon icon={faBox}></FontAwesomeIcon> {produtoSelecionado.codigo} {produtoSelecionado.descricao} 
                    <Button type="link" size="small" onClick={devinculaItem} style={{"color": "red", marginTop: "-10px", marginTop: "-15px", right: "-15px", position: "absolute"}}><FontAwesomeIcon icon={faMinusCircle}></FontAwesomeIcon></Button>
                </h3>
            
        </Col>
            
        </>)
    } else{

        return (<>
            <AutoComplete style={{
                        width: "100%",
                    }}             
                    dropdownMatchSelectWidth={500}
                    id="searchProduto"
                    onSearch={onFilter(false)}
                    options={options}
                    onSelect={onSelect}
                    
                >
                    <Input.Search  placeholder="Informe seu produto" enterButton={
                        <FontAwesomeIcon icon={faRedo}></FontAwesomeIcon>
                    }  onSearch={onFilter(true)} />
                </AutoComplete>
        </>)
    }
}

export {AutoCompleteProdutos};